<template>
  <div class="content_box">
    <div class="industryCode" id="ManageTable">
      <div class="industryCode_header">
        <div class="industryCode_logo">
          <img
            style="width: 29px; height: 29px"
            src="@/assets/imgs/icon/icon_apply.png"
            alt
          />
        </div>
        <h3>申请修改</h3>
      </div>
      <el-tabs v-model="activeName">
        <el-tab-pane label="未办理申请" name="notDone">
          <not-done v-if="activeName == 'notDone'"></not-done>
        </el-tab-pane>
        <el-tab-pane label="通过申请" name="adopt">
          <adopt v-if="activeName == 'adopt'"></adopt>
        </el-tab-pane>
        <el-tab-pane label="未通过申请" name="notPass">
          <not-pass v-if="activeName == 'notPass'"></not-pass>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import notDone from "./notDone/index";
import adopt from "./adopt/index";
import notPass from "./notPass/index";
export default {
  components: {
    notDone,
    adopt,
    notPass,
  },
  data() {
    return {
      activeName: "notDone",
    };
  },
  methods: {},
};
</script>
<style lang="less" scoped>
.content_box {
  padding: 20px 30px 30px;
}
@media (max-width: 1200px) {
  .content_box {
    padding: 20px 10px 30px;
  }
}
.industryCode {
  box-shadow: 0px 0px 50px #ccc;
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
  .industryCode_header {
    height: 31px;
    width: 100%;
    display: flex;
    margin-bottom: 30px;
    .industryCode_logo {
      margin: 2px 20px 0 2px;
    }
    h3 {
      font-size: 24px;
      height: 100%;
      margin: 0;
      color: #444444;
    }
  }
  .industryCode_form {
    height: 70px;
    width: 100%;
    box-sizing: border-box;
    border-bottom: 1px solid rgba(155, 155, 155, 0.25);
    margin-bottom: 20px;
    .el-form {
      .el-form-item {
        margin-right: 30px;
      }
    }
  }
  .industryCode_add_user {
    margin-bottom: 20px;
  }
  .el-dialog {
    .addUser {
      .el-form-item {
        .el-select {
          width: 100%;
        }
      }
    }
  }
}
.detail {
  width: 100%;
  height: 100%;
  cursor: pointer;
  color: #5584ff;
}
</style>